export const BASE_LEVEL = 0;

export const isBaseLevel = (level: number) => level === BASE_LEVEL;
